import React from "react";
import PaymentIcon from "components/payment-icon";
import { useGlobalContext } from "context/global";
import clsx from "clsx/lite";

const PaymentInfo = ({ data, className }) => {
	const { translation } = useGlobalContext();
	const creditCardTypes = [
		"CustomerCreditCard", "CustomerRemoteCreditCard", "CustomerShopPayAgreement",
		"CustomerRemoteBraintreeCreditCard", "AuthorizeNetCustomerPaymentProfile"
	];
	const paypalTypes = ["CustomerPaypalBillingAgreement", "PaypalBillingAgreement"];

	const { type, card, payPal } = data || {};

	if (creditCardTypes.includes(type))
		return <CreditCard data={card} className={className} translation={translation.subscription.payment} />;
	else if (paypalTypes.includes(type))
		return <Paypal data={payPal} className={className} copy={translation.subscription.payment?.paypal} />;
	else
		return null;
};

const Paypal = ({ data, translation, className }) => (
	<div className="flex gap-2 xs:gap- md:gap-10 w-full items-center text-left text-sm">
		<PaymentIcon brand="paypal" />
		<span className={`w-4/5 ${className} break-words`}>{translation} {data?.email}</span>
	</div>
);

const CreditCard = ({ data, translation, className = null }) => {
	const now = new Date();
	let expYear = data?.expiryYear ?? data?.year;
	// If the year is less than 100, it's a 2-digit year
	if (expYear < 100)
		expYear += 2000;

	const expMonth = data?.expiryMonth ?? data?.month;
	const expiryDate = new Date(expYear, expMonth);
	const isExpired = expiryDate < now;

	return (
		<div className="flex gap-2 xs:gap- md:gap-10 items-center w-full">
			<PaymentIcon brand={data?.brand} />
			<div className="flex justify-start flex-col gap-2 text-left w-4/5 font-body">
				<span className={clsx(className, "text-base")}>
					{translation?.ending_with} {data?.lastDigits}</span>
				<span className={clsx(className, "text-base break-words", isExpired && "text-red-500")}>
					{translation[`expire${isExpired ? "d" : "s"}_at`]}{" "}
					{expMonth}/{expYear}
				</span>
			</div>
		</div>
	);
};



export default PaymentInfo;